module.exports = __webpack_public_path__ + "static/media/clocktime.25121a8c.svg";